var BlockCompiler = require("../../compiler/compiler.js");
var CBlockType = require("../../compiler/types.js");
var CoreFunctions = require("../../compiler/corefunc.js");

BlockCompiler.defineBlock("loader_costume_scale", {
  type: CBlockType.OUTPUT,
  func: function (utils) {
    var COSTUME = utils.getInput("COSTUME", "null");

    return `(await sprite.blockGetCostumeScale(${COSTUME}))`;
  },
});
